<template>
    <div class="home">
      <img src="../../public/favicon.png" />
      <h3>Post Receipt Webview</h3>
      <p>powered by Olsera</p>
    </div>
</template>

<script>
export default {
  name: "HomeView",
};
</script>

